 <template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">


                        <h2 class="mb-5">
                            <font-awesome-icon icon="info"/>
                            {{$t('text.status.cacheInstances')}}

                            <router-link :to="{name: 'CacheTestClient'}" class="btn btn-info float-right" v-if="$globalFunctions.getAppVersionData('environment') !== 'PROD'"><i class="fas fa-vial"></i> {{$t('text.status.cacheTestClient')}}</router-link>
                            <div class="clearfix"></div>
                        </h2>


                        <div>
                                    <div class="row mt-3">
                                        <div class="col-12">
                                            <vue-good-table
                                                    styleClass="vgt-table table table-hover table-striped"
                                                    :columns="columns"
                                                    :rows="cacheInstances"
                                                    :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: $t('text.status.writeSearchPhrase'),
                                                    }"
                                                    :sort-options="{
                                                         enabled: true,
                                                         initialSortBy: {field: 'name', type: 'asc'}
                                                      }">

                                                <div slot="emptystate">
                                                    <div class="text-center"><i class="fa fa-exclamation-triangle"></i> <em>{{$t('text.globals.noData')}}</em></div>
                                                </div>

                                                <template slot="table-row" slot-scope="props">
                                                    <span v-if="props.column.field == 'name'">
                                                        {{props.row.name}}
                                                    </span>

                                                    <span v-else-if="props.column.field == 'uuid'">
                                                       <span v-bind:title="props.row.uuid">{{props.row.uuid.length >= 10 ? props.row.uuid.substring(0,10) + '...' :  props.row.uuid}}</span>
                                                    </span>

                                                    <div v-else-if="props.column.field == 'enabled'" class="text-left">
                                                        <i v-if="props.row.enabled" class="fa fa-check-circle"></i>
                                                        <i v-else class="fa fa-times-circle text-black-50"></i>
                                                    </div>

                                                    <div v-else-if="props.column.field == 'state'">
                                                        <em v-if="!props.row.state">{{$t('text.status.noInfo')}}</em>
                                                        <span v-else>{{props.row.state}}</span>
                                                    </div>

                                                    <span v-else-if="props.column.field == 'id'">
                                                        <router-link :to="{ name: 'Cache', params: { id: props.row.id } }"
                                                           class="btn btn-primary btn-sm"
                                                           v-if="$globalFunctions.checkForPermission('DODAJ_PREDPOMNILNIK')"
                                                        ><i class="fa fa-edit"></i> {{$t('text.globals.edit')}}
                                                            </router-link>

                                                          <a class="btn btn-danger btn-sm text-white ml-1"
                                                             @click="deleteInstanceConfirmation(props.row.id, props.row.name)"
                                                             v-if="$globalFunctions.checkForPermission('DODAJ_PREDPOMNILNIK')"
                                                          ><i
                                                                  class="fa fa-trash"></i> {{$t('text.globals.delete')}}</a>
                                                    </span>
                                                </template>
                                            </vue-good-table>
                                        </div>
                                    </div>
                        </div>


                        <router-link :to="{ name: 'Cache', params: {} }" class="btn btn-sm btn-primary text-white mt-2 float-right"
                                     v-if="$globalFunctions.checkForPermission('DODAJ_PREDPOMNILNIK')"
                        ><i
                                class="fa fa-plus-circle"></i> {{$t('text.status.addCacheInstance')}}
                        </router-link>
                        <div class="clearfix"></div>

                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faInfo} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';
    import iconMarkerGreen from '../assets/images/icon-marker-green.svg'
    import iconMarkerGray from '../assets/images/icon-marker-gray.svg'
    import iconMarkerYellow from '../assets/images/icon-marker-yellow.svg'
    import iconMarkerRed from '../assets/images/icon-marker-red.svg'
    import {VueGoodTable} from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css'

    library.add(faInfo);

    export default {
        name: 'Status',
        components: {
            SidebarNavigation,
            VueGoodTable
        },

        data() {
            return {
                zoom: 8,
                center: L.latLng(46.1075569, 14.9918961),
                url: '//{s}.tile.osm.org/{z}/{x}/{y}.png',
                attribution: "",
                columns: [
                    {
                        label: this.$t('text.status.name'),
                        field: 'name',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: this.$t('text.status.uuid'),
                        field: 'uuid',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: this.$t('text.status.state'),
                        field: 'state',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label:  this.$t('text.status.activity'),
                        field: 'enabled',
                        type: 'boolean',
                        sortable: true,
                    },
                    {
                        label: this.$t('text.globals.actions'),
                        field: 'id',
                        type: 'text',
                        sortable: false,
                        width: '200px'
                    }
                ],
                cacheInstances: []
            };
        },

        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        mounted: function () {
            this.getCaches();
        },

        computed: {
            getActiveTab() {
                return this.$store.getters.getStatusPageActiveTab
            },
            generateMarkers() {

                let markers = [];

                _.each(this.cacheInstances, function (val) {
                    let markerIcon = null;
                    let statusText = '';
                    let statusColorClass = '';

                    switch (val.state) {
                        case 'ok':
                            markerIcon = iconMarkerGreen;
                            statusText = this.$t('text.globals.ok');
                            statusColorClass = 'text-success';
                            break;
                        case 'warning':
                            markerIcon = iconMarkerYellow;
                            statusText = this.$t('text.status.problem');
                            statusColorClass = 'text-warning';
                            break;
                        case 'problem':
                            markerIcon = iconMarkerRed;
                            statusText = this.$t('text.status.error');
                            statusColorClass = 'text-danger';
                            break;
                    }

                    if (!val.active) {
                        markerIcon = iconMarkerGray;
                        statusText = this.$t('text.status.noInfo');
                        statusColorClass = 'text-secondary';
                    }

                    markers.push(
                        {
                            id: val.id,
                            latlng: L.latLng(val.geoLat, val.geoLong),
                            content: '<h6 class="mt-1">' + val.name + '</h6>'+ this.$t('text.status.activity') + ': <b class="' + (val.enabled ? 'text-black' : 'text-black-50') +
                                '">' + (val.enabled ? '<i class="fa fa-check-circle"></i>' : '<i class="fa fa-times-circle"></i>') + '</b><br/>' + this.$t('text.globals.status') +
                                ': <b class="' + statusColorClass + '">' + statusText + '</b><div class="text-right"><a href="/#/cache/' + val.id + '" class="btn btn-primary btn-sm text-white"><i class="fa fa-edit"></i> ' + this.$t('text.globals.edit') + '</a></div>',
                            icon: L.icon({
                                iconUrl: markerIcon,
                                iconSize: [38, 38], // size of the icon
                                iconAnchor: [16, 38], // point of the icon which will correspond to marker's location
                                popupAnchor: [3, -30] // point from which the po
                            })
                        }
                    );
                });

                console.log(markers);

                return markers

            }
        },

        methods: {

            centerMap() {
                const _this = this;

                let map = _this.$refs.map.mapObject;
                map.panTo(_this.center);
                map.setZoom(_this.zoom);
            },
            getCaches() {
                const _this = this;

                axios.get(config.alfrescoServiceApi + 'ehramba/nodeSynch/cache-service')
                    .then((res) => {

                        console.log(res.data);

                        _this.cacheInstances = res.data;

                        this.isLoading = false;


                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });

            },
            deleteInstanceConfirmation(cacheId, cacheName) {
                const _this = this;

                this.$swal({
                    title: this.$t('text.globals.warningTitle'),
                    text:  this.$t('text.status.cacheDeletionSwal.prompt') + " " + cacheName + "?",
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: this.$t('text.globals.cancel'),
                            value: null,
                            visible: true,
                            className: "",
                            closeModal: true,
                        },
                        confirm: {
                            text: this.$t('text.globals.delete'),
                            value: true,
                            visible: true,
                            className: "",
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteInstance(cacheId);

                            case null:

                                return;

                                break;

                            default:

                        }
                    });
            },


            deleteInstance(cacheId) {
                const _this = this;

                axios.delete(config.alfrescoServiceApi + 'ehramba/nodeSynch/cache-service/' + cacheId)
                    .then((res) => {

                        _this.$router.go();
                        console.log("response: ", res);

                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;
                    });

            },
            setActiveTab(activeTab) {
                console.log(activeTab)
                this.$store.dispatch('setStatusPageActiveTab', activeTab);
            }

        }


    };
</script>



// WEBPACK FOOTER //
// src/pages/Status.vue